module.exports = __webpack_public_path__ + "static/ADAMdownarrow-dbd8344a466123160785943ef3c608ee.png";